"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const use_impression_observer_1 = tslib_1.__importDefault(require("./use-impression-observer"));
const use_analytics_1 = require("../../use-analytics");
const toArray = (maybe) => {
    if (maybe === undefined) {
        return [];
    }
    else if (Array.isArray(maybe)) {
        return maybe;
    }
    else {
        return [maybe];
    }
};
function maybeTrackEvents({ analytics, events, fireOnceOnly, }) {
    if (fireOnceOnly) {
        toArray(events).forEach((event) => analytics.trackEventOnce(event));
    }
    else {
        toArray(events).forEach((event) => analytics.trackEvent(event));
    }
}
function useTrackComponent({ onCreateImpressionWhenView: passedOnCreateImpresssionWhenView, onImpressionTrackEvent, onImpressionTrackEventOnce, onClickTrackEvent, context, }) {
    const analytics = (0, use_analytics_1.useAnalytics)(context);
    const onCreateImpressionWhenView = (0, react_1.useCallback)((data) => {
        passedOnCreateImpresssionWhenView?.(data);
        maybeTrackEvents({
            analytics,
            events: onImpressionTrackEvent?.(data),
            fireOnceOnly: false,
        });
        maybeTrackEvents({
            analytics,
            events: onImpressionTrackEventOnce?.(data),
            fireOnceOnly: true,
        });
    }, [
        analytics,
        passedOnCreateImpresssionWhenView,
        onImpressionTrackEvent,
        onImpressionTrackEventOnce,
    ]);
    const { inViewRef } = (0, use_impression_observer_1.default)({
        onCreateImpressionWhenView,
    });
    const onClick = (0, react_1.useCallback)((e) => {
        maybeTrackEvents({
            analytics,
            events: onClickTrackEvent?.(e),
            fireOnceOnly: false,
        });
    }, [analytics, onClickTrackEvent]);
    return { inViewRef, onClick };
}
exports.default = useTrackComponent;
//# sourceMappingURL=use-track-component.js.map